/**
 * Using defineProperty for compatibility reasons with:
 * * ACF (Advanced Custom Fields - Wordpress). 
 * * Wowbook 
 * * etc...
 */
try {
    Object.defineProperty(Array.prototype, "id", {
        enumerable: false,
        value: function (this: any[], id: number) {
            var l: number = this.length;
            for (var i: number = 0; i < l; ++i)
                if (this[i].id == id)
                    return this[i];
            return null;
        }
    });
} catch (error) {

}

// var addArrayFunction = function (name: string, f: any) {
//     Object.defineProperty(Array.prototype, name, {
//         enumerable: false,
//         value: f
//     });
// }

// addArrayFunction("id", function (this: any[], id: number) {
//     var l: number = this.length;
//     for (var i: number = 0; i < l; ++i)
//         if (this[i].id == id)
//             return this[i];
//     return null;
// });

// addArrayFunction("where", function (this: any[], property: string, value: any) {
//     var l: number = this.length;
//     var res = [];
//     for (var i: number = 0; i < l; ++i)
//         if (this[i][property] == value)
//             res.push(this[i]);
//     return res;
// });

// addArrayFunction("whereFirst", function (this: any[], property: string, value: any) {
//     var l: number = this.length;
//     for (var i: number = 0; i < l; ++i)
//         if (this[i][property] == value)
//             return this[i];
//     return null;
// });

// addArrayFunction("pushUnique", function (this: any[], value: any): boolean {
//     if (this.indexOf(value) >= 0)
//         return false;
//     this.push(value);
//     return true;
// });

// addArrayFunction("equals", function (this: any[], b: any[]): boolean {
//     if (!this && !b)
//         return true;
//     if (!this && b)
//         return false;
//     if (this && !b)
//         return false;

//     if (this.length != b.length)
//         return false;

//     var l = this.length;
//     for (var i = 0; i < l; ++i) {
//         if (b.indexOf(this[i]) < 0)
//             return false;
//     }
//     return true;
// });

// addArrayFunction("remove", function (this: any[], value: any) {
//     var idx = this.indexOf(value);
//     if (idx < 0)
//         return;
//     this.splice(idx, 1);
// });

//Fix for IE when no console is available (its created when the debug-console opens)
if (!window.console) {
    (<any>window)["console"] = { log: function (): void { }, warn: function (): void { } };
}

/**
 * @see https://greensock.com/3-migration/#overwrite
 */
if (window.gsap) {
    gsap.defaults({ overwrite: "auto" });
}